import React from 'react'
import { Link } from 'gatsby'

const ClassHero = ({ slice }) => {

    return (
        <section className="class-hero">
            <h1 className="text-blue text-center mt-100 mb-48">
                {slice.primary.title.text}
                <br />
                {slice.primary.description.text}
            </h1>
            <div className="hero-buttons mb-100">
                <div><Link to={'/enroll/' + slice.primary.enroll_button_link.uid} className="hero-buttons-left button-solid mr-24">{slice.primary.enroll_button_text.text}</Link></div>
                <div><a href="#class-information" className="hero-buttons-right button-inverse">{slice.primary.more_info_button_text.text}</a></div>
            </div>
            <img src={slice.primary.image.url} alt={slice.primary.image.alt}  className="image-center"/>
            <div className="class-featured">
                <div className="container">
                    <div>
                        <img src={slice.primary.featured_1_icon.url} alt={slice.primary.featured_1_icon.alt} className="class-featured-icon"/>
                        <p className="class-featured-label">{slice.primary.featured_1_label.text}</p>
                        <p className="class-featured-text-1">{slice.primary.featured_1_text.text}</p>
                        <p className="class-featured-text-2">{slice.primary.featured_1_description.text}</p>
                    </div>
                    <div>
                        <img src={slice.primary.featured_2_icon.url} alt={slice.primary.featured_2_icon.alt} className="class-featured-icon"/>
                        <p className="class-featured-label">{slice.primary.featured_2_label.text}</p>
                        <p className="class-featured-text-1">{slice.primary.featured_2_text.text}</p>
                        <p className="class-featured-text-2">{slice.primary.featured_2_description.text}</p>
                    </div>
                    <div>
                        <img src={slice.primary.featured_3_icon.url} alt={slice.primary.featured_3_icon.alt} className="class-featured-icon"/>
                        <p className="class-featured-label">{slice.primary.featured_3_label.text}</p>
                        <p className="class-featured-text-1">{slice.primary.featured_3_text.text}</p>
                        <p className="class-featured-text-2">{slice.primary.featured_3_description.text}</p>
                    </div>
                    <div>
                        <img src={slice.primary.featured_4_icon.url} alt={slice.primary.featured_4_icon.alt} className="class-featured-icon"/>
                        <p className="class-featured-label">{slice.primary.featured_4_label.text}</p>
                        <p className="class-featured-text-1">{slice.primary.featured_4_text.text}</p>
                        <p className="class-featured-text-2">{slice.primary.featured_4_description.text}</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ClassHero